import type { ResponseEventParams } from '@webapp/survey/src/entities/response-machine';
import type { QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { MatrixApi } from './common/matrix';

export class MatrixSingleAnswerApi extends MatrixApi {
    public change(
        { answersActors, groupsActors, responseActor, id: questionId }: QuestionContext,
        { value, answerId, groupId }: ResponseEventParams,
    ): void {
        // const { groupId } = responseActor.getSnapshot().context;
        groupsActors.forEach((groupActor) => {
            if (groupId !== groupActor.getSnapshot().context.id) {
                groupActor.getSnapshot().context.responses[answerId].send({ type: 'CHANGE', value: false, questionId });
            }
        });
        responseActor.send({ type: 'SET', value });
        // response.value = value;

        answersActors.forEach((answerActor) => {
            const answer = answerActor.getSnapshot().context;
            if (answer.valid) {
                return;
            }
            let isAnswered = false;
            groupsActors.forEach((groupActor) => {
                const resp = groupActor.getSnapshot().context.responses[answer.id].getSnapshot().context;
                if (resp?.value) {
                    isAnswered = true;
                }
            });
            if (isAnswered) {
                answerActor.send({ type: 'SET_VALID', value: true });
            }
        });
    }
}
